import React from 'react'
import * as $ from 'jquery';
import { orderPaymentsLoad, orderPaymentEdit } from '../../../../redux/actions/order/orderPaymentActions';
import { useDispatch } from 'react-redux';

export default function RefundsButton(props) {
  const { children, orderId } = props
  const dispatch = useDispatch()

  const handlePaymentEdit = () => {
    dispatch(orderPaymentEdit('New'))
    // dispatch(orderPaymentsLoad(orderId, { filter: { sale_refund_payments: true }, include: ['staff'] }))
    dispatch(orderPaymentsLoad(orderId, { rpp: 999, filter: { payment_type: ['sale', 'refund'], amount_present: true }, include: ['staff'] }))
    $("#orderRefundForm-modal").modal()
    $('#Refund-tab').tab('show')
  }

  return (
    <span className="pointer" onClick={handlePaymentEdit}>
      {children}
    </span>
  )
}
